module.exports = __webpack_public_path__ + "media/images/icons/bluetooth-4a2f9c815e69d725716eacd48489e2d3.svg";